export default function shopSection(context) {

  // Get container
  const filterContainer = context.querySelector('#products-container');
  if (!filterContainer) return;

  // Filter
  const productDivs = context.querySelectorAll('#products-container .product');
  const filterProducts = url => {
    let category = url.split('/').reverse()[0];
    let summary = document.querySelector(`[data-summary-url="${category}"]`);

    // Fill the summary
    const intro = document.getElementById('shop-intro');
    if (summary) intro.innerHTML = summary.innerHTML;

    productDivs.forEach(block => {
      block.classList[(block.dataset.category !== category && category !== 'shop') ? 'add' : 'remove']('hidden');
      
      // if (category === 'shop') {
      //   intro.classList.remove('hidden');
      // } else {
      //   intro.classList.add('hidden');
      // }

    });
  };

  // Filter clicks
  const filterLinks = context.querySelectorAll('#products-filters a');
  filterLinks.forEach(link => {
    link.addEventListener('click', event => {
      event.preventDefault();

      // Cross fade, filter on hidden
      filterContainer.classList.add('reload');
      setTimeout(() => {
        filterProducts(link.href);
        filterContainer.classList.remove('reload');
      }, 80);

      // Reset active links
      filterLinks.forEach(l => { l.classList.remove('active'); });
      link.classList.add('active');
    });
  });

  // Intitial or pathed
  let filterPath = filterLinks[0].href;
  if (window.location.pathname === '/shop') {
    filterPath = filterLinks[0].href;
  } else {
    filterPath = window.location.pathname;
  }

  // Initial filter
  filterProducts(filterPath);
}



// WEBPACK FOOTER //
// ./source/javascript/sections/shop.js